import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaGlobe, FaCheckCircle, FaBan, FaUserShield, FaSearch, FaLink, FaSyncAlt, FaCookieBite } from "react-icons/fa";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";

export default function Websiteusage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Navbarsticky */}
            <Navbarsticky />
            <div className="website-container">
            </div>

            {/* MAIN CONTENT */}
            <div className="website-section py-5 w-100">
                <Container fluid className="w-100">
                    <Row className="justify-content-center">
                        <h1 className="website-title">
                            <FaGlobe className="title-icon" />
                            Website Usage Policy
                        </h1>
                        <Col lg={9} md={11}>
                            <div className="website-card">

                                <p>
                                    This Usage Policy outlines the permitted and prohibited uses of
                                    our travel booking website.
                                </p>

                                {/* 1. Permitted Usage */}
                                <div className="website-block">
                                    <h5>
                                        <FaCheckCircle className="block-icon" />
                                        Permitted Usage
                                    </h5>
                                </div>

                                <p>You may:</p>

                                <ul>
                                    <li>Search and book travel packages</li>
                                    <li>Create an account and manage your bookings</li>
                                    <li>Make payments through authorized payment gateways</li>
                                    <li>Submit reviews or feedback (subject to moderation)</li>
                                </ul>

                                {/* 2. Prohibited Usage */}
                                <div className="website-block">
                                    <h5>
                                        <FaBan className="block-icon" />
                                        Prohibited Usage
                                    </h5>
                                </div>

                                <p>You may <strong>not</strong>:</p>

                                <ul>
                                    <li>Use the website for fraudulent or illegal activities</li>
                                    <li>Post or transmit abusive, defamatory, or harmful content</li>
                                    <li>Use bots or automated systems to access the site</li>
                                    <li>Attempt to breach website security or access data unauthorizedly</li>
                                    <li>Share login credentials or allow multiple users on one account</li>
                                </ul>

                                {/* 3. Account Security */}
                                <div className="website-block">
                                    <h5>
                                        <FaUserShield className="block-icon" />
                                        Account Security
                                    </h5>
                                </div>

                                <p>
                                    You are responsible for maintaining the confidentiality of your
                                    account information.
                                </p>
                                <p>Notify us immediately of any unauthorized access.</p>

                                {/* 4. Monitoring & Enforcement */}
                                <div className="website-block">
                                    <h5>
                                        <FaSearch className="block-icon" />
                                        Monitoring and Enforcement
                                    </h5>
                                </div>

                                <p>We reserve the right to:</p>

                                <ul>
                                    <li>Suspend or terminate accounts violating our policy</li>
                                    <li>Report suspicious activities to law enforcement</li>
                                    <li>Remove any content violating our terms</li>
                                </ul>

                                {/* 5. Cookies & Tracking */}
                                <div className="website-block">
                                    <h5>
                                        <FaCookieBite className="block-icon" />
                                        Cookies & Tracking
                                    </h5>
                                </div>

                                <p>
                                    Our website uses cookies and tracking technologies for
                                    functionality, analytics, and marketing. By using the site, you
                                    consent to this tracking.
                                </p>

                                {/* 6. External Links */}
                                <div className="website-block">
                                    <h5>
                                        <FaLink className="block-icon" />
                                        External Links
                                    </h5>
                                </div>

                                <p>
                                    We may link to third-party websites. We are not responsible for
                                    their content or privacy practices.
                                </p>

                                {/* 7. Amendments */}
                                <div className="website-block">
                                    <h5>
                                        <FaSyncAlt className="block-icon" />
                                        Amendments
                                    </h5>
                                </div>

                                <p>
                                    We may update this Usage Policy periodically. Continued use of
                                    the site implies acceptance of the revised policy.
                                </p>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* Footer */}
            <Footer />
        </>
    );
}
